import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { AnimationItem } from 'lottie-web';

import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { LottiePresentConfig } from './LottieProvider.types';
import animations from './animations';
import useBreakpoint from '../../hooks/useBreakpoint';
import AnimationPlayer from '../AnimationPlayer/AnimationPlayer.web';
import { AnimationPlayerProps } from '../AnimationPlayer/AnimationPlayer.types';

export let Lottie = {
  present: (_: LottiePresentConfig) => {},
  preload: (_: LottiePresentConfig['animation']) => {},
};

const style: StyleProp<ViewStyle> = [
  StyleSheet.absoluteFill,
  { pointerEvents: 'none', zIndex: 99 },
];

const webStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 999,
  pointerEvents: 'none',
} as const;

function LottieProvider() {
  const ref = useRef<AnimationItem>(null);
  const breakpoint = useBreakpoint();
  const [config, setConfig] = useState<AnimationPlayerProps>();

  const onAnimationFinish = useCallback(() => {
    config?.onAnimationFinish?.(false);

    setConfig(undefined);
  }, [config]);

  useEffect(() => {
    Lottie = {
      present: (config: LottiePresentConfig) => {
        const { animation, ...rest } = config;

        setConfig({ ...rest, source: animations[animation] });
      },
      preload: async (animation: LottiePresentConfig['animation']) => {
        const anim = animations[animation];

        if (typeof anim === 'function') {
          await anim();
        } else if (anim[breakpoint]) {
          await anim[breakpoint]();
        }
      },
    };
  }, [breakpoint]);

  if (!config || !config.source) {
    return null;
  }

  return (
    <AnimationPlayer
      ref={ref}
      style={style}
      webStyle={webStyle}
      loop={false}
      autoPlay
      {...config}
      onComplete={onAnimationFinish}
    />
  );
}

export default memo(LottieProvider);
